import { createStore, applyMiddleware, compose } from 'redux';
import { batchedSubscribe } from 'redux-batched-subscribe';
import transactionHandler from 'redux-batched-subscribe-transaction';
import middleware from './middleware';
import reducer from './reducer';

function getDevToolsEnhancer() {
  const noop = next => next;
  return typeof window !== 'undefined' &&
    process.env.NODE_ENV !== 'production' &&
    window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__() : noop;
}

export default (analytics, initialState) => {
  const middlewareList = middleware({ analytics });
  const middlewareEnhancer = applyMiddleware(...middlewareList);
  const batchingEnhancer = batchedSubscribe(transactionHandler);
  const devToolsEnhancer = getDevToolsEnhancer();
  const applyEnhancers = compose(middlewareEnhancer, batchingEnhancer, devToolsEnhancer);
  const createEnhancedStore = applyEnhancers(createStore);
  return createEnhancedStore(reducer, initialState);
};



/** WEBPACK FOOTER **
 ** ./app/store/createStore.js
 **/